import { render, staticRenderFns } from "./email-shortcuts.vue?vue&type=template&id=86f05972"
import script from "./email-shortcuts.vue?vue&type=script&lang=js"
export * from "./email-shortcuts.vue?vue&type=script&lang=js"
import style0 from "./fullsize.less?vue&type=style&index=0&prod&lang=less&external"
import style1 from "./email-shortcuts.less?vue&type=style&index=1&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports